export default __webpack_public_path__ + "static/media/stovepipe.a2050665.jpg";